import React from 'react'
import moment from 'moment/moment'
import { Link } from 'react-router-dom'
import { Tag } from 'antd'
import classNames from 'classnames'

function LazeCuttingErrorRow(props) {
    const { item, setType } = props
    const { batch_id, laser_error } = item
    const { name, lasers} = batch_id
    const barcode_number = item.item.marketplace
    const item_number = item.item.item_number
    const barcodeNumber = barcode_number + '_' + item_number
    const created_at = item.item.created_at
    const product_types = item.item.type
    const error_info = laser_error.error_info
    const brand = item.item.brand
    const partner = batch_id.partner
    const sewing_partner = batch_id.sewing_partner
    const mark_error_at = laser_error.mark_error_at
    const user_mark = laser_error.user_mark
    const user_laze = lasers.length > 0 ? lasers[0].cutter_name : ''

    const _generateLevel = (level) => {
        const color = level === 'highest' ? 'rgb(255 45 0)' : level === 'high' ? '#FFD300' : ''
        return <Tag className={classNames(`tag-${level}`)}
            color={color}>{level !== undefined ? level : 'medium'}</Tag>
    }

    const onClickType = (value) => {
        setType(value)
    }

    return (
        <tr>
            <td>
                {!!barcode_number &&
                    <Link
                        to={`/order-item?template=${barcodeNumber}`}
                        target='_blank'>
                        #{barcodeNumber}
                    </Link>
                }
            </td>
            <td className='nameLo'>
                <Link to={`/batches/${batch_id._id}`} className='w-100'>
                    {name}
                </Link>
                {
                    _generateLevel(item.level)
                }
            </td>
            <td>{moment(created_at).format('HH:mm DD/MM/YYYY') || '-'}</td>
            <td className="ProductType">
                {!!product_types &&
                    <span className="mr-2" onClick={() => onClickType([product_types])}>{product_types}</span>
                }
                {!!brand && !!brand.name &&
                    <div className="Brand">
                        <span className="mr-2" >{brand.name}</span>
                    </div>
                }
            </td>
            <td>
                {user_laze}
            </td>
            <td>
                {error_info || '-'}
            </td>
            <td>{user_mark || '-'}</td>
            <td>{!!partner && !!partner.name ? partner.name : '-'}</td>
            <td>{!!sewing_partner && !!sewing_partner.name ? sewing_partner.name : '-'}</td>
            <td>{moment(mark_error_at).format('HH:mm DD/MM/YYYY') || '-'}</td>
        </tr>
    )
}

export default LazeCuttingErrorRow